<div class="portal--header">
    <h1 class="heading">Consumer search</h1>
    <form action="" class="std-form form__search">
        <div class="input-addon input-addon__btn-side" [formGroup]="form">
            <input type="text" id="consumer-search" class="input-addon__btn-side--input" [formControl]="form.controls['search']" placeholder="Search by name, site or address" (keyup)="searchUpdated($event.target.value)" #searchInput>
            <button (click)="search()" class="std-btn input-addon__btn-side--btn focus-element"><span class="focus--content" tabindex="-1">Search</span></button>
        </div>
    </form>
</div>
<div class="portal--main">
    <div class="flex-grid space-between bottom stack-sm">
        <div class="flex-grid--item">
            <button id="toggle-button" class="focus-element" collapsible [collapsibleSection]="collapsibleSection" [collapsibleTitle]="collapsibleTitle"><span class="focus--content" tabindex="-1"><span class='accordion-toggle open' #collapsibleTitle style="margin-top: 0;">Filter <svg class="ic-arrow"><use xlink:href="#ic-arrow" href="#ic-arrow"></use></svg></span></span></button>
            <div class="collapsible" #collapsibleSection>
                <div class="btn-group">
                    <ng-container *ngFor="let filter of filterList; let i = index">
                        <button class="std-btn filter focus-element" *ngIf="!filter.isDisabled" [ngClass]="{'active': filterList[i].isClicked}" (mouseup)="filterUpdated(i)"><span class="focus--content" tabindex="-1">{{filter.label}} <span class="detail">{{filter.amount}}</span></span></button>
                    </ng-container>
                </div>

            </div>
        </div>
        <div class="flex-grid--item organise-select">
            <label for="">Site:</label>
            <select name="siteId" id="" class="select__standalone" [(ngModel)]="selectedSiteId" (change)="updateSite()" #siteId>
                <option [ngValue]="0">All</option>
                <option [ngValue]="site.siteId" *ngFor="let site of sites">{{site.siteName}}</option>
            </select>
        </div>
    </div>
    <div class="module-wrapper">
        <div class="module drop-shadow bottom">
            <h3 *ngIf="isSearching">Searching...</h3>
            <p *ngIf="!isSearching && results.length == 0" class="text-center">No matching results</p>
            <table *ngIf="!isSearching && results.length > 0" class="std-table stacked-sm">
                <thead>
                <th>Consumer name</th>
                <th>Site</th>
                <th>Supply address</th>
                <th>Account from</th>
                <th>Account to</th>
                <th>Issue?</th>
                <th></th></thead>
                <tbody>
                    <tr *ngFor="let result of results">
                        <td data-label="Consumer name"><span class="ic-wrapper" title="Billing consumer" *ngIf="result.consumerType === 'Billing'"><svg class="ic"><use xlink:href="#ic-consumer-billing" href="#ic-consumer-billing"></use></svg></span>
                                              <span class="ic-wrapper" title="PAYG consumer"><svg class="ic" *ngIf="result.consumerType === 'PAYG'"><use xlink:href="#ic-consumer-payg" href="#ic-consumer-payg"></use></svg></span> {{result.consumerName}}
                                              <span class="ic-wrapper" title="Vulnerable consumer" *ngIf="result.vulnerable"><svg class="ic"><use xlink:href="#ic-vulnerable" href="#ic-vulnerable"></use></svg></span></td>
                        <td data-label="Site">{{result.siteName}}</td>
                        <td data-label="Supply address">{{result.consumerAddress}}</td>
                        <td data-label="Account from">{{result.consumerFromDate | date:'dd/MM/yyyy'}}</td>
                        <td data-label="Account to">{{result.consumerTodate | date:'dd/MM/yyyy'}}</td>
                        <td data-label="Issue?"><div class="ic-beware-wrapper"><span class="ic-beware" *ngIf="result.issueCount > 0">!</span><span class="no" *ngIf="result.issueCount > 0">{{result.issueCount}}</span></div></td>
                        <td class="text-right"><a [routerLink]="['/portal/'+ clientId +'/consumer',result.consumerId]" class="text-link focus-element"><span class="focus--content">View</span></a></td>
                    </tr>
                </tbody>
            </table>
            <app-pagination *ngIf="!isSearching" [page]="page" [pages]="totalPages" (pageChange)="pageSelected($event)"></app-pagination>
        </div>
    </div>
</div>
